module.exports = __webpack_public_path__ + "img/start.11ad1720.png";